import React, { useState } from 'react';
import { Button, ButtonGroup, Menu, MenuItem } from '@mui/material';
import Icon from '../../../../../../muiComponents/Icon';
import Tooltip from '../../../../../../muiComponents/Tooltip';
import useTranslate from '../../../../../../customHooks/useTranslate';
import {
    ConnectivityLogsSortDirection,
    ConnectivityLogsSortState,
} from '../../../../types/zitoneoServicesTypes';
import {
    CONNECTIVITY_LOGS_SORT_DIRECTION_ICONS,
    CONNECTIVITY_LOGS_SORT_KEY_LABELS,
    CONNECTIVITY_LOGS_SORT_KEY_OPTIONS,
} from '../../../../utils/zitoneoServicesUtils';

interface ConnectivityLogsSortProps {
    sortedBy: ConnectivityLogsSortState;
    onChange: (sortedBy: ConnectivityLogsSortState) => void;
}

const ConnectivityLogsSort = ({
    sortedBy,
    onChange,
}: ConnectivityLogsSortProps) => {
    const translate = useTranslate();
    const [anchorElSortedByKey, setAnchorElSortedByKey] =
        useState<HTMLElement | null>(null);

    const closeSortedByKeyMenu = () => setAnchorElSortedByKey(null);

    const toggleDirection = () => {
        onChange({
            key: sortedBy.key,
            direction:
                sortedBy.direction === ConnectivityLogsSortDirection.ASC
                    ? ConnectivityLogsSortDirection.DESC
                    : ConnectivityLogsSortDirection.ASC,
        });
    };

    return (
        <div className='flex flex-align-center gap-20'>
            <div className='flex gap-5 text-secondary-color'>
                <Icon iconName='SortOutlined' />
                <p>{translate('sort_by')}</p>
            </div>
            <ButtonGroup
                className='connectivity-logs-panel__sort-button-group'
                size='small'
            >
                <Button onClick={e => setAnchorElSortedByKey(e.currentTarget)}>
                    {translate(CONNECTIVITY_LOGS_SORT_KEY_LABELS[sortedBy.key])}
                </Button>
                <Button
                    onClick={toggleDirection}
                    className='connectivity-logs-panel__sort-direction-button'
                >
                    <Tooltip
                        titleText={
                            sortedBy.direction ===
                            ConnectivityLogsSortDirection.ASC
                                ? 'ascending'
                                : 'descending'
                        }
                    >
                        <span className='flex flex-align-center'>
                            <Icon
                                iconName={
                                    CONNECTIVITY_LOGS_SORT_DIRECTION_ICONS[
                                        sortedBy.direction
                                    ]
                                }
                            />
                        </span>
                    </Tooltip>
                </Button>
            </ButtonGroup>
            <Menu
                open={!!anchorElSortedByKey}
                anchorEl={anchorElSortedByKey}
                onClose={closeSortedByKeyMenu}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {CONNECTIVITY_LOGS_SORT_KEY_OPTIONS.map(option => (
                    <MenuItem
                        key={option}
                        selected={option === sortedBy.key}
                        onClick={() => {
                            onChange({
                                key: option,
                                direction: sortedBy.direction,
                            });
                            closeSortedByKeyMenu();
                        }}
                    >
                        <span className='text-capitalize'>
                            {translate(
                                CONNECTIVITY_LOGS_SORT_KEY_LABELS[option]
                            )}
                        </span>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default ConnectivityLogsSort;
